import _ from 'lodash';
import queryString from 'query-string';
import Store from '../store/Store';
import { URLS } from '../store/Constants';
import ViewUtil from '../ViewUtil';
import ArrayUtil from '../util/ArrayUtil';
import { setMainThreadListner, actionOnInit } from '../util/MainThreadUtil';
import System from '../basic/System';
import Storage from '../protocol/Storage';
import { HISTORY_END_URL } from '../util/Constants';

/*
  ARGS - it is parsed search (the part of URL that goes after ?).
  The search is in query string format.
  ARGS are used as one more global state, so rendering depending on ARGS happens the same way as rendering based on window.gs
  If you want to set new args call window.setArgs({ key: 'value' }), if you want just update the args call window.setARGS({ ...window.ARGS, key: 'value' })
  As an example of how it works take a look at lightboxes.
  Pretty simple concept as to me.
 */
window.ARGS = queryString.parse(location.search);

window.setARGS = (args, replace = false, replaceState = false) => {
  const newArgs = replace
    ? args
    : {
        ...window.ARGS,
        ...args
      };
  if (!_.isEqual(window.ARGS, newArgs)) {
    window.ARGS = newArgs;
    const data =  null;
    window.showBackHistoryBtn = true;
    window.showForwardHistoryBtn = false;
    const urlParams = queryString.stringify(window.ARGS);
    Store.put(URLS, Store.get(URLS).concat(newArgs));
    if (replaceState)  {
      window.history.replaceState(data, null, `?${urlParams}`);
    } else {
        window.history.pushState(data, null, `?${urlParams}`);
    }
    Storage.set(HISTORY_END_URL,window.location.href );
  }
};

window.onpopstate = () => {
  const prevArgs = window.ARGS;
  window.ARGS = queryString.parse(location.search);
  const urls = [...Store.get(URLS)];
  urls.pop();
  Store.put(URLS, urls);

  const prevPwd = ViewUtil.getPwd(prevArgs);
  const pwd = ViewUtil.getPwd();
  if (!ArrayUtil.areDeepEqual(prevPwd, pwd)) {
    ViewUtil.setPwd(pwd);
  }

  window.render();
};

setMainThreadListner(() => {
  actionOnInit();
});
